exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#not-found h1{font-size:30px}#not-found .logo{margin-bottom:4rem}#not-found .logo img{width:18rem}", ""]);

// exports
